import { useEffect, useRef } from "react";
import { getCalcJob, getCalcJobResult } from "../lib/api";

/**
 * A2-479 (operator 2026-10-22: "Acknowledging at sign-off adds the sale to
 * the return"). Sign-off answered RECALCULATING_TO_INCLUDE_SALES with the
 * id of a re-run that adds the acknowledged held EU sales as intra-EU
 * sales. Wait for it, then hand the new calculation over — that one is
 * signed. Polls every 2 s, stops on COMPLETE / FAILED / CANCELLED or unmount.
 */
export const useIncludeHeldRecalc = ({ jobId, onResult, onError, intervalMs = 2000 }) => {
  const cbs = useRef({ onResult, onError });
  cbs.current = { onResult, onError };
  useEffect(() => {
    if (!jobId) return undefined;
    let stopped = false;
    let timer = null;
    const tick = async () => {
      try {
        const job = await getCalcJob(jobId);
        if (stopped) return;
        if (job?.status === "COMPLETE") {
          const result = await getCalcJobResult(jobId);
          if (!stopped) cbs.current.onResult?.(result);
          return;
        }
        if (job?.status === "FAILED" || job?.status === "CANCELLED") {
          if (!stopped) cbs.current.onError?.(job?.error || job?.status);
          return;
        }
      } catch (e) {
        if (!stopped) cbs.current.onError?.(e?.message || String(e));
        return;
      }
      timer = setTimeout(tick, intervalMs);
    };
    tick();
    return () => { stopped = true; if (timer) clearTimeout(timer); };
  }, [jobId, intervalMs]);
};
